var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';
import "../../enums/accordion.js";
import "../../enums/alert.js";
import "../../enums/avatar.js";
import "../../enums/breakpoints.js";
import "../../enums/button.js";
import "../../enums/code-editor.js";
import "../../enums/colors.js";
import "../../enums/combobox.js";
import "../../enums/date.js";
import "../../enums/drag-and-drop.js";
import "../../enums/dialog.js";
import "../../enums/divider.js";
import "../../enums/dropdown.js";
import "../../enums/fieldset.js";
import "../../enums/font-icon.js";
import "../../enums/fonts.js";
import { HeadingLevels } from "../../enums/headings.js";
import "../../enums/input.js";
import "../../enums/keys.js";
import "../../enums/list.js";
import "../../enums/listbox.js";
import "../../enums/loader.js";
import "../../enums/margin.js";
import "../../enums/option.js";
import "../../enums/pill.js";
import "../../enums/placements.js";
import "../../enums/popout.js";
import "../../enums/privacy.js";
import "../../enums/radio-group.js";
import "../../enums/status.js";
import "../../enums/switch.js";
import "../../enums/table.js";
import "../../enums/tooltip.js";
import "../../enums/transitions.js";
import "../../enums/widths.js";
import "../../themes/alert.js";
import "../../themes/button.js";
import "../../themes/checkbox.js";
import "../../themes/divider.js";
import "../../themes/dropdown.js";
import "../../themes/fieldset.js";
import { fontFamilyBook, fontSizeXxSmall, fontWeightBook, fontSizeSmall, fontSizeMedium, fontSizeLarge, fontFamilyMedium, fontSizeXLarge, fontWeightMedium, fontFamilyBold, fontSizeXxLarge, fontWeightBold } from "../../themes/fonts.js";
import "../../themes/input.js";
import "../../themes/list.js";
import "../../themes/listbox.js";
import "../../themes/loader.js";
import "../../themes/option.js";
import "../../themes/popout.js";
import "../../themes/switch.js";
import "../../themes/themes.js";
import "../../themes/tooltip.js";
var getHeadingLevel = function getHeadingLevel(options) {
  var level = options.level;
  switch (level) {
    case HeadingLevels.h1:
      {
        return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-size: ", "px;\n        font-weight: ", ";\n        line-height: 50px;\n      "])), fontFamilyBold, fontSizeXxLarge, fontWeightBold);
      }
    case HeadingLevels.h2:
      {
        return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-size: ", "px;\n        font-weight: ", ";\n        line-height: 40px;\n      "])), fontFamilyMedium, fontSizeXLarge, fontWeightMedium);
      }
    case HeadingLevels.h3:
      {
        return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-size: ", "px;\n        font-weight: ", ";\n        line-height: 28px;\n      "])), fontFamilyBook, fontSizeLarge, fontWeightBook);
      }
    case HeadingLevels.h4:
      {
        return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-size: ", "px;\n        font-weight: ", ";\n        line-height: 24px;\n      "])), fontFamilyBook, fontSizeMedium, fontWeightBook);
      }
    case HeadingLevels.h5:
      {
        return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-size: ", "px;\n        font-weight: ", ";\n        line-height: 22px;\n      "])), fontFamilyBook, fontSizeSmall, fontWeightBook);
      }
    // HeadingLevels.h6
    default:
      {
        return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-size: ", "px;\n        font-weight: ", ";\n        line-height: 18px;\n      "])), fontFamilyBook, fontSizeXxSmall, fontWeightBook);
      }
  }
};
export { getHeadingLevel };